<template lang="html">
  <server-form
    v-slot="slotProps"
    :form-action="formAction"
    :form="form"
    :submit-btn="submitBtn">
    <div
      v-for="question in freeformQuestions"
      :key="question.id"
      class="row">
      <div class="col-md-12">
        <My360Textarea
          :form="form"
          :error-bag="slotProps.errors"
          :label="question.question"
          :generic-error-msg="__('feedback_account_name')"
          :validation-name="__('label_account_name')"
          :prop="`freeform_questions[${question.id}]`"
          autofocus/>

          <form
            :action="`/surveys/${observerSurvey.id}/freeform-questions/answer/save`"
            method="POST"
          >
            <input
              :value="csrfToken"
              type="hidden"
              name="_token">
            <input
              :value="form[`freeform_questions[${question.id}]`]"
              type="hidden"
              name="answer">
            <input
              :value="question.id"
              type="hidden"
              name="question_id">
            <button
              class="btn btn-light btn-sm"
              type="submit">
              {{ __('btn_save') }}
            </button>
          </form>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="custom-control custom-checkbox">
              <input
                id="feedback_opt_in_check"
                v-model="form.feedbackOptIn"
                name="feedback_opt_in_check"
                value="true"
                type="checkbox"
                class="custom-control-input">
              <label
                class="custom-control-label"
                for="feedback_opt_in_check">
                {{ __('help_participant_with_ongoing', [{participant_first_name: participant.first_name}]) }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </server-form>
</template>
<script>
import formAction from '../mixins/formAction'

export default {
  name: 'ObserverSurveyCompleteForm',

  mixins: [formAction],

  props: {
    participant: {
      type: Object,
      required: true
    },
    observerSurvey: {
      type: Object,
      required: true
    },
    freeformQuestions: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    freeformAnswers: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },

  data () {
    return {
      form: {
        feedbackOptIn: true
      }
    }
  },

  computed: {
    submitBtn () {
      var data = [{ participant_first_name: this.participant.first_name }]
      return {
        text: (this.form.feedbackOptIn ? this.__('complete_save_btn_with_opt_in', data) : this.__('complete_save_btn_without_opt_in', data))
      }
    }
  },

  mounted () {
    if (this.freeformAnswers) {
      this.freeformAnswers.forEach(answer => {
        this.$set(this.form, `freeform_questions[${answer.freeform_question_id}]`, answer.answer)
      })
    }
  }
}
</script>
